import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'

@Component({
  selector: 'ddc-button-n-one-action',
  templateUrl: './ddc-button-n-one-action.component.html',
  styleUrls: ['./ddc-button-n-one-action.component.scss'],
  imports: [AngularMaterialsModules, CommonModule],
})
export class DdcButtonNOneActionComponent {
  @Input() _label: string
  @Input() _icon: string
  @Input() _color: string
  @Input() _dynamicRoute: string
  @Input() _hasBorder: boolean
  @Input() _selected: boolean
  @Input() _colorfulIcon: boolean = false
  @Input() _themeMode: boolean = false
  @Output() _click = new EventEmitter<void>()
  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private themeSubscription: Subscription

  constructor(public themeService: ThemeService) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }
  onButtonClick(): void {
    if (this._themeMode) {
      this._click.emit()
    }
  }
}
